import { Typography } from 'antd';
import { observer } from 'mobx-react-lite';
import { SpinnerFullWidth } from 'src/components/Spinner/SpinnerFullWidth';
import styled from 'styled-components';

export type BasePageProps = Omit<React.HTMLAttributes<any>, 'title'> & {
    title?: React.ReactNode;
    pageName: string;
    isLoading?: boolean;
    isUpdating?: boolean;
    type?: PageType;
};

export const BasePage: React.FC<BasePageProps> = observer(
    ({ children, isLoading, title, type = PageType.BASE, ...props }) => {
        return (
            <StyledPage type={type} {...props}>
                {title && <StyledPageTitle>{title}</StyledPageTitle>}
                {isLoading ? <SpinnerFullWidth /> : children}
            </StyledPage>
        );
    },
);

export enum PageType {
    BASE,
    WIDE_FORM,
    SIMPLE_FORM,
    FULL,
}

type StyledPageProps = { type?: PageType; pageName?: string };

export const StyledPage = styled.div.attrs<StyledPageProps>((props) => ({
    'data-pagename': props.pageName,
}))<StyledPageProps>`
    max-width: ${(props) => getMaxWithByType(props.type)};
    margin: 0 auto;
    position: relative;
    padding: 2rem 1.82rem 2rem 1.82rem;
    .ant-list {
        margin-left: 1.18rem;
    }
`;

const getMaxWithByType = (type?: PageType) => {
    if (type === PageType.WIDE_FORM) {
        return '800px';
    }
    if (type === PageType.SIMPLE_FORM) {
        return '580px';
    }
    if (type === PageType.FULL) {
        return '100%';
    }

    return '80rem';
};

const StyledPageTitle = styled(Typography.Title)`
    font-size: 40px;
    line-height: 105%;
    color: var(--text-color);

    &.ant-typography {
        margin-bottom: 35px;
    }
`;
